import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout.js';
import * as General from '../General/General.js';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import { Modal } from "react-bootstrap";
import Delete from '../Delete/Delete.js';


const BankIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    let navigate = useNavigate();
    const DeleteRef = useRef()
    const DeletePOSRef = useRef()
    const DeletCheckBookRef = useRef()
    const [List, setList] = useState([]);
    const [POSList, setPOSList] = useState([]);


    const [TitleSearch, setTitleSearch] = useState('');
    const [IsActiveSearch, setIsActiveSearch] = useState(1);
    const [IsDefaultSearch, setIsDefaultSearch] = useState(-1);
    const [AccountOwnerSearch, setAccountOwnerSearch] = useState('');
    const [ShowModal, setShowModal] = useState(false);
    const [ShowPOSModal, setShowPOSModal] = useState(false);
    const [ShowCheckBookModal, setShowCheckBookModal] = useState(false);

    const [Id, setId] = useState(General.GuidEmpty());
    const [Title, setTitle] = useState('');
    const [IsActive, setIsActive] = useState(true);
    const [ShowTitle, setShowTitle] = useState('');
    const [AccountOwner, setAccountOwner] = useState('');
    const [AccountNo, setAccountNo] = useState('');
    const [Branch, setBranch] = useState('');
    const [ShabaNo, setShabaNo] = useState('');
    const [OnlineActive, setOnlineActive] = useState(0);
    const [IsDefault, setIsDefault] = useState(0);
    const [KartNo, setKartNo] = useState("");
    const [sortColumn, setSortColumn] = React.useState();
    const [sortType, setSortType] = React.useState();
    const [loading, setLoading] = React.useState(false)
    const [POSPermission, setPOSPermission] = React.useState(false)
    const [CheckDefindPermission, setCheckDefindPermission] = React.useState(false)
    const [POSId, setPOSId] = useState(General.GuidEmpty());
    const [POSTitle, setPOSTitle] = useState('');
    const [POSIsActive, setPOSIsActive] = useState(true);

    const [CheckBookId, setCheckBookId] = useState(General.GuidEmpty());
    const [CheckBookTitle, setCheckBookTitle] = useState('');
    const [CheckBookIsActive, setCheckBookIsActive] = useState(true);
    const [CheckBookStartNo, setCheckBookStartNo] = useState(0);
    const [CheckBookStartSayadiNo, setCheckBookStartSayadiNo] = useState(0);
    const [CheckBookPageCount, setCheckBookPageCount] = useState(0);
    const [CheckBookPageUsedCount, setCheckBookPageUsedCount] = useState(0);
    const [CheckBookSerialNo, setCheckBookSerialNo] = useState("");
    const [CheckBookList, setCheckBookList] = useState([]);

    //#endregion


    //#region Methods

    const Search = () => {

        var RequestOptions = {
            data: {
                "Title": TitleSearch,
                "AccountOwner": AccountOwnerSearch,
                "IsActive": IsActiveSearch,
                "IsDefault": IsDefaultSearch
            },
            url: General.ApiRoute() + "/Bank/Search",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }

        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    var temp = [];
                    for (let index = 0; index < result.data.length; index++) {
                        temp.push({
                            row: index + 1,
                            Id: result.data[index].id,
                            Code: result.data[index].code,
                            IsActive: result.data[index].isActive,
                            AccountOwner: result.data[index].accountOwner,
                            AccountNo: result.data[index].accountNo,
                            Branch: result.data[index].branch,
                            ShabaNo: result.data[index].shabaNo,
                            OnlineActive: result.data[index].onlineActive,
                            IsDefault: result.data[index].isDefault,
                            KartNo: result.data[index].kartNo,
                            ShowTitle: result.data[index].showTitle,
                            Title: result.data[index].title,
                        })

                    }
                    setList(temp);

                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )
    }

    const Reset = () => {
        setId(General.GuidEmpty());
        setTitle('');
        setIsActive(true);
        setShowTitle('');
        setAccountOwner('');
        setAccountNo('');
        setBranch('');
        setShabaNo('');
        setOnlineActive(0);
        setIsDefault(0);
        setKartNo("");
    }

    const Save = () => {
        if (Title == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("عنوان اجباری می باشد")), 'topCenter')
            return;
        }
        if (ShowTitle == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("عنوان جهت نمایش اجباری می باشد")), 'topCenter')
            return;
        }
        if (AccountNo == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("شماره حساب اجباری می باشد")), 'topCenter')
            return;
        }
        if (AccountOwner == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("صاحب حساب اجباری می باشد")), 'topCenter')
            return;
        }
        if (Branch == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("شعبه بانک اجباری می باشد")), 'topCenter')
            return;
        }
        if (ShabaNo == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("شماره شبا اجباری می باشد")), 'topCenter')
            return;
        }
        if (KartNo == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("شماره کارت اجباری می باشد")), 'topCenter')
            return;
        }

        var RequestOptions = {
            data: {
                "Id": Id,
                "Title": Title,
                "AccountNo": AccountNo,
                "Branch": Branch,
                "AccountOwner": AccountOwner,
                "ShabaNo": ShabaNo,
                "KartNo": KartNo,
                "ShowTitle": ShowTitle,
                "OnlineActive": OnlineActive ? 1 : 0,
                "IsDefault": IsDefault ? 1 : 0,
                "IsActive": IsActive ? 1 : 0,
            },
            url: General.ApiRoute() + "/Bank/Save",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }

        console.dir(RequestOptions.data);
        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    if (result.data == "OK") {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')

                        Search();
                        if (Id != General.GuidEmpty())
                            setShowModal(false);
                        Reset();

                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }
                }).catch((error) => {
                    console.dir(error)
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )
    }



    const ShowDelete = (id, title) => {
        DeleteRef.current.Get(23, id, title);
    }

    const ShowEdit = (id) => {
        Reset();
        setId(id);
        setShowModal(true);
        trackPromise(
            fetch(General.ApiRoute() + '/Bank/GetById', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'Id': id
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    setTitle(result.title);
                    setId(result.id);
                    setIsActive(result.isActive);
                    setShowTitle(result.showTitle);
                    setAccountOwner(result.accountOwner);
                    setAccountNo(result.accountNo);
                    setBranch(result.branch);
                    setShabaNo(result.shabaNo);
                    setOnlineActive(result.onlineActive);
                    setIsDefault(result.isDefault);
                    setKartNo(result.kartNo);
                })
        )
    }

    const ShowNew = (id) => {
        Reset();
        setShowModal(true);
        setId(id);
    }

    const ShowNewPOS = (id, title) => {
        setShowPOSModal(true);
        setId(id);
        setShowTitle(title);
        setPOSId(General.GuidEmpty());
        setPOSIsActive(true);
        setPOSTitle("");
        SearchPOS(id);

    }

    const SavePOS = () => {
        if (POSTitle == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("عنوان اجباری می باشد")), 'topCenter')
            return;
        }

        var RequestOptions = {
            data: {
                "Id": POSId,
                "Title": POSTitle,
                "BankAccountId": Id,
                "IsActive": POSIsActive ? 1 : 0,
            },
            url: General.ApiRoute() + "/POS/Save",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    if (result.data == "OK") {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')

                        SearchPOS(Id);
                        setPOSTitle("");
                        setPOSIsActive(true)

                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )
    }

    const SearchPOS = (Bid) => {

        setPOSList([]);
        console.dir(Bid)
        var RequestOptions = {
            data: {
                "BankAccountId": Bid,
                "IsActive": -1
            },
            url: General.ApiRoute() + "/POS/Search",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }

        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    var temp = [];
                    for (let index = 0; index < result.data.length; index++) {
                        temp.push({
                            row: index + 1,
                            Id: result.data[index].id,
                            Code: result.data[index].code,
                            IsActive: result.data[index].isActive,
                            Title: result.data[index].title,
                            FinancialBalance: result.data[index].financialBalance
                        })

                    }
                    setPOSList(temp);

                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )

    }

    const ShowPOSEdit = (id, title, isActive) => {
        setPOSId(id);
        setPOSIsActive(isActive);
        setPOSTitle(title);
    }

    const ShowPOSDelete = (id, title) => {
        DeletePOSRef.current.Get(24, id, title);
    }



    const ShowNewCheckBook = (id, title) => {
        setShowCheckBookModal(true);
        setId(id);
        setShowTitle(title);
        ResetChekBook()
        SearchCheckBook(id);

    }

    const ResetChekBook = () => {
        setCheckBookId(General.GuidEmpty());
        setCheckBookTitle('');
        setCheckBookIsActive(true);
        setCheckBookStartNo(0);
        setCheckBookStartSayadiNo(0);
        setCheckBookPageCount(0);
        setCheckBookPageUsedCount(0);
        setCheckBookSerialNo("");
    }


    const SaveCheckBook = () => {
        console.dir(Id)
        if (CheckBookTitle == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("عنوان اجباری می باشد")), 'topCenter')
            return;
        }
        if (CheckBookPageCount == "" || CheckBookPageCount == 0) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("تعداد برگ دسته چک اجباری می باشد")), 'topCenter')
            return;
        }
        if (CheckBookSerialNo == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("سریال اجباری می باشد")), 'topCenter')
            return;
        }
        if (CheckBookStartNo == "" || CheckBookStartNo == 0) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("شماره اولین برگ اجباری می باشد")), 'topCenter')
            return;
        }
        if (CheckBookStartSayadiNo == "" || CheckBookStartSayadiNo == 0) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("شماره صیادی اولین برگ اجباری می باشد")), 'topCenter')
            return;
        }


        var RequestOptions = {
            data: {
                "Id": CheckBookId,
                "Title": CheckBookTitle,
                "BankAccountId": Id,
                "PageCount": CheckBookPageCount,
                "PageUsedCount": CheckBookPageUsedCount,
                "SerialNo": CheckBookSerialNo,
                "StartNo": CheckBookStartNo,
                "StartSayadiNo": CheckBookStartSayadiNo,
                "IsActive": CheckBookIsActive ? 1 : 0,
            },
            url: General.ApiRoute() + "/CheckBook/Save",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    if (result.data == "OK") {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')

                        SearchCheckBook(Id);
                        ResetChekBook()

                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )
    }

    const SearchCheckBook = (Bid) => {

        console.dir(Bid)
        setCheckBookList([]);
        var RequestOptions = {
            data: {
                "BankAccountId": Bid,
            },
            url: General.ApiRoute() + "/CheckBook/GetByBankAccountId",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }

        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    var temp = [];
                    for (let index = 0; index < result.data.length; index++) {
                        temp.push({
                            row: index + 1,
                            Id: result.data[index].id,
                            SerialNo: result.data[index].serialNo,
                            IsActive: result.data[index].isActive,
                            Title: result.data[index].title,
                            PageCount: result.data[index].pageCount,
                            PageUsedCount: result.data[index].pageUsedCount,
                            StartNo: result.data[index].startNo,
                            StartSayadiNo: result.data[index].startSayadiNo,

                        })

                    }
                    setCheckBookList(temp);

                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )

    }

    const ShowCheckBookEdit = (id) => {

        ResetChekBook();
        setCheckBookId(id);
        trackPromise(
            fetch(General.ApiRoute() + '/CheckBook/GetById', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'Id': id
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    setCheckBookTitle(result.title);
                    setCheckBookIsActive(result.isActive);
                    setCheckBookTitle(result.title);
                    setCheckBookPageCount(result.pageCount);
                    setCheckBookPageUsedCount(result.pageUsedCount);
                    setCheckBookSerialNo(result.serialNo);
                    setCheckBookStartNo(result.startNo);
                    setCheckBookStartSayadiNo(result.startSayadiNo);
                })
        )
    }

    const ShowCheckDelete = (id, title) => {
        DeletCheckBookRef.current.Get(26, id, title);
    }

    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 23);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        Search();

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }

    const CheckPOSPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 24);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    console.dir(result.toString())
                    if (result.toString() != "OK") {
                        setPOSPermission(false);
                    }
                    else {
                        setPOSPermission(true);

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }

    const CheckCheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 26);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result != "OK") {
                        setCheckDefindPermission(false);
                    }
                    else {
                        setCheckDefindPermission(true);

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }

    const handelKeyDown = (e, row) => {
        if (e.key == "Enter") {
            Search();
        }
        if (e.shiftKey && e.code === "KeyN") {
            ShowNew(General.GuidEmpty());
        }

    }

    useEffect(() => {
        CheckPermission();
        CheckPOSPermission();
        CheckCheckPermission();
        document.title = "تعریف بانک و حساب بانکی ";
        const inputElement = document.querySelector('.FocusItem');
        if (inputElement) {
            inputElement.focus();
        }
    }, [])
    //#endregion







    return (

        <Layout title="تعریف بانک و حساب بانکی">


            <div className="h-100 p-1" onKeyDown={handelKeyDown}>
                <rsuite.Panel className="bg-white ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={Search}>  جستجو</rsuite.Button>
                                <rsuite.Button appearance="primary" color="green" size="xs" className="m-1" onClick={() => ShowNew(General.GuidEmpty(), "")}>  جـــدید</rsuite.Button>
                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />
                    <rsuite.Row className='p-1'>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                            <label> عنوان</label>
                            <rsuite.Input value={TitleSearch} className='FocusItem' onChange={(e) => setTitleSearch(e)} />
                        </rsuite.Col>


                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                            <label> صاحب حساب </label>
                            <rsuite.Input value={AccountOwnerSearch} onChange={(e) => setAccountOwnerSearch(e)} />
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                            <label>وضعیت</label>
                            <select className="rs-input" onChange={(e) => setIsActiveSearch(e.target.value)} value={IsActiveSearch}>
                                <option value="-1">انتخاب نمایید</option>
                                <option value="0">غیر فعال </option>
                                <option value="1">فعال  </option>
                            </select>
                        </rsuite.Col>
                    </rsuite.Row>
                    <div className="h-90 p-0">
                        <div className="h-100-y p-0">
                            <rsuite.Row className='p-1'>
                                <rsuite.Col xxl={24} xl={24} lg={24} mdHidden xsHidden smHidden>
                                    <rsuite.Panel className="bg-white mt-2 p-0">

                                        <rsuite.Table
                                            height={550}
                                            data={List}
                                            wordWrap="break-word"
                                            loading={loading}
                                            headerHeight={70}
                                        >
                                            <rsuite.Table.Column width={50} align="center" >
                                                <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell dataKey="row" />
                                            </rsuite.Table.Column>

                                            <rsuite.Table.Column width={100} resizable>
                                                <rsuite.Table.HeaderCell>کد</rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell dataKey="Code" />
                                            </rsuite.Table.Column>
                                            <rsuite.Table.Column flexGrow={1} fixed resizable>
                                                <rsuite.Table.HeaderCell>بانک</rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell dataKey="Title" />
                                            </rsuite.Table.Column>
                                            <rsuite.Table.Column flexGrow={1} fixed resizable>
                                                <rsuite.Table.HeaderCell>شعبه</rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell dataKey="Branch" />
                                            </rsuite.Table.Column>
                                            <rsuite.Table.Column fullText flexGrow={1} resizable>
                                                <rsuite.Table.HeaderCell>صاحب حساب</rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell dataKey="AccountOwner" />
                                            </rsuite.Table.Column>
                                            <rsuite.Table.Column fullText flexGrow={1} resizable>
                                                <rsuite.Table.HeaderCell>شماره حساب</rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell dataKey="AccountNo" />
                                            </rsuite.Table.Column>
                                            <rsuite.Table.Column fullText flexGrow={2} resizable>
                                                <rsuite.Table.HeaderCell>شماره کارت</rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell dataKey="KartNo" />
                                            </rsuite.Table.Column>
                                            <rsuite.Table.Column fullText flexGrow={2} resizable>
                                                <rsuite.Table.HeaderCell>شماره شبا</rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell dataKey="ShabaNo" />
                                            </rsuite.Table.Column>

                                            <rsuite.Table.Column fullText width={100} resizable>
                                                <rsuite.Table.HeaderCell>فعال   </rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell>
                                                    {(rowData) => {
                                                        return <>

                                                            {rowData.IsActive == 1 ?

                                                                <BiIcon.BiCheckCircle className="text-success fs-6" />
                                                                :
                                                                <BiIcon.BiXCircle className="text-danger fs-6" />
                                                            }
                                                        </>


                                                    }}

                                                </rsuite.Table.Cell>
                                            </rsuite.Table.Column>
                                            <rsuite.Table.Column fullText width={100} resizable>
                                                <rsuite.Table.HeaderCell> در پرداخت آنلاین فعال </rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell>
                                                    {(rowData) => {
                                                        return <>

                                                            {rowData.OnlineActive == 1 ?

                                                                <BiIcon.BiCheckCircle className="text-success fs-6" />
                                                                :
                                                                <BiIcon.BiXCircle className="text-danger fs-6" />
                                                            }
                                                        </>

                                                    }}

                                                </rsuite.Table.Cell>
                                            </rsuite.Table.Column>
                                            <rsuite.Table.Column fullText width={100} resizable>
                                                <rsuite.Table.HeaderCell> شماره حساب پیش فرض </rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell>
                                                    {(rowData) => {
                                                        return <>

                                                            {rowData.IsDefault == 1 ?

                                                                <BiIcon.BiCheckCircle className="text-success fs-6" />
                                                                :
                                                                <BiIcon.BiXCircle className="text-danger fs-6" />
                                                            }
                                                        </>

                                                    }}

                                                </rsuite.Table.Cell>
                                            </rsuite.Table.Column>

                                            <rsuite.Table.Column fixed="right" flexGrow={1} >
                                                <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>

                                                <rsuite.Table.Cell>
                                                    {(rowData) => {
                                                        return <>
                                                            <rsuite.Whisper placement="autoVerticalStart" trigger="click" speaker={
                                                                <rsuite.Popover full className='PopoverMenu'>
                                                                    <rsuite.Dropdown.Menu  >
                                                                        <rsuite.Dropdown.Item onClick={() => ShowEdit(rowData.Id)}>ویرایش</rsuite.Dropdown.Item>
                                                                        <rsuite.Dropdown.Item className={rowData.FinancialBalance == 0 && rowData.CheckNo == 0 && rowData.POSNo == 0 ? '' : "hide"} onClick={() => ShowDelete(rowData.Id, rowData.ShowTitle)}>حذف</rsuite.Dropdown.Item>
                                                                        <rsuite.Dropdown.Item className={POSPermission ? '' : "hide"} onClick={() => ShowNewPOS(rowData.Id, rowData.ShowTitle)}>تعریف POS</rsuite.Dropdown.Item>
                                                                        <rsuite.Dropdown.Item className={CheckDefindPermission ? '' : "hide"} onClick={() => ShowNewCheckBook(rowData.Id, rowData.ShowTitle)}>تعریف دسته چک</rsuite.Dropdown.Item>
                                                                    </rsuite.Dropdown.Menu>
                                                                </rsuite.Popover>
                                                            }>
                                                                <rsuite.IconButton appearance="subtle" icon={<BiIcon.BiDotsHorizontalRounded />} />
                                                            </rsuite.Whisper>
                                                        </>
                                                    }}
                                                </rsuite.Table.Cell>

                                            </rsuite.Table.Column>
                                        </rsuite.Table>

                                    </rsuite.Panel>
                                </rsuite.Col>
                                <rsuite.Col md={24} xs={24} sm={24} xlHidden xxlHidden lgHidden>
                                    <rsuite.Panel className="bg-white mt-2 p-0">
                                        {List.map((rowData) =>

                                            <rsuite.Card className={rowData.IsActive == 0 ? "border border-danger mt-2" : " mt-2"}>
                                                <rsuite.Card.Header className='bg-light' as="h6" >
                                                    <rsuite.Row>
                                                        <rsuite.Col xs={20}>
                                                            <b>

                                                                {rowData.ShowTitle}
                                                            </b>

                                                        </rsuite.Col>
                                                        <rsuite.Col xs={4} className='text-start'>
                                                            <rsuite.Whisper placement="autoVerticalStart" trigger="click" speaker={
                                                                <rsuite.Popover full className='PopoverMenu'>
                                                                    <rsuite.Dropdown.Menu  >
                                                                        <rsuite.Dropdown.Item onClick={() => ShowEdit(rowData.Id)}>ویرایش</rsuite.Dropdown.Item>
                                                                        <rsuite.Dropdown.Item className={rowData.FinancialBalance == 0 && rowData.CheckNo == 0 && rowData.POSNo == 0 ? '' : "hide"} onClick={() => ShowDelete(rowData.Id, rowData.ShowTitle)}>حذف</rsuite.Dropdown.Item>
                                                                        <rsuite.Dropdown.Item className={POSPermission ? '' : "hide"} onClick={() => ShowNewPOS(rowData.Id, rowData.ShowTitle)}>تعریف POS</rsuite.Dropdown.Item>
                                                                        <rsuite.Dropdown.Item className={CheckDefindPermission ? '' : "hide"} onClick={() => ShowNew(rowData.Id, rowData.ShowTitle)}>تعریف دسته چک</rsuite.Dropdown.Item>
                                                                    </rsuite.Dropdown.Menu>
                                                                </rsuite.Popover>
                                                            }>
                                                                <rsuite.IconButton appearance="subtle" icon={<BiIcon.BiDotsHorizontalRounded />} />
                                                            </rsuite.Whisper>
                                                        </rsuite.Col>
                                                    </rsuite.Row>
                                                </rsuite.Card.Header>
                                                <rsuite.Card.Body >
                                                    <p>
                                                        <b>بانک</b> : {rowData.Title}
                                                    </p>
                                                    <p>
                                                        <b>شعبه</b> : {rowData.Branch}
                                                    </p>
                                                    <p>
                                                        <b>صاحب حساب</b> : {rowData.AccountOwner}
                                                    </p>
                                                    <p>
                                                        <b>شماره حساب</b> : {rowData.AccountNo}
                                                    </p>
                                                    <p>
                                                        <b>شماره کارت</b> : {rowData.KartNo}
                                                    </p>
                                                    <p>
                                                        <b>شماره شبا</b> : {rowData.ShabaNo}
                                                    </p>





                                                </rsuite.Card.Body>

                                            </rsuite.Card>
                                        )}


                                    </rsuite.Panel>
                                </rsuite.Col>
                            </rsuite.Row>
                        </div>
                    </div>

                </rsuite.Panel >
            </div >




            <Modal show={ShowModal} onHide={() => setShowModal(false)} size="xl" backdrop="static" keyboard={false}>
                <Modal.Header >

                    <Modal.Title className='fs-5'><b>تعریف حساب بانکی</b> </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <rsuite.Grid fluid>

                        <rsuite.Row className="p-1">
                            <rsuite.Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                                <BiIcon.BiSolidStar className={Title == "" ? 'text-danger' : 'hide'} />  <label>بانک</label>
                                <rsuite.Input value={Title} onChange={(e) => (setTitle(e), setShowTitle(e + ' - ' + KartNo))} />
                            </rsuite.Col>
                            <rsuite.Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                                <BiIcon.BiSolidStar className={Branch == "" ? 'text-danger' : 'hide'} />  <label>شعبه</label>
                                <rsuite.Input value={Branch} onChange={(e) => (setBranch(e))} />
                            </rsuite.Col>
                            <rsuite.Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                                <BiIcon.BiSolidStar className={AccountOwner == "" ? 'text-danger' : 'hide'} />  <label>صاحب حساب</label>
                                <rsuite.Input value={AccountOwner} onChange={(e) => (setAccountOwner(e))} />
                            </rsuite.Col>
                            <rsuite.Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                                <BiIcon.BiSolidStar className={AccountNo == "" ? 'text-danger' : 'hide'} />  <label>شماره حساب</label>
                                <rsuite.InputNumber value={AccountNo} onChange={(e) => (setAccountNo(e))} />
                            </rsuite.Col>
                            <rsuite.Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                                <BiIcon.BiSolidStar className={KartNo == "" ? 'text-danger' : 'hide'} />  <label>شماره کارت</label>
                                <rsuite.Input value={KartNo} onChange={(e) => (setKartNo(e), setShowTitle(Title + ' - ' + e))} />
                            </rsuite.Col>
                            <rsuite.Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                                <BiIcon.BiSolidStar className={ShabaNo == "" ? 'text-danger' : 'hide'} />  <label>شماره شبا</label>
                                <rsuite.Input value={ShabaNo} onChange={(e) => (setShabaNo(e))} />
                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <BiIcon.BiSolidStar className={ShowTitle == "" ? 'text-danger' : 'hide'} />  <label>عنوان جهت نمایش </label>
                                <rsuite.Input value={ShowTitle} onChange={(e) => (setShowTitle(e))} />
                            </rsuite.Col>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <rsuite.Checkbox onChange={(e, checked) => setIsActive(checked)} checked={IsActive} value={IsActive} /> &nbsp;   فعال می باشد
                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <rsuite.Checkbox onChange={(e, checked) => setOnlineActive(checked)} checked={OnlineActive} value={OnlineActive} /> &nbsp;  مورد استفاده در پرداخت آنلاین می باشد
                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <rsuite.Checkbox onChange={(e, checked) => setIsDefault(checked)} checked={IsDefault} value={IsDefault} /> &nbsp;  استفاده به عنوان شماره حساب پیش فرض
                            </rsuite.Col>

                        </rsuite.Row>

                    </rsuite.Grid>
                </Modal.Body>
                <Modal.Footer>
                    <rsuite.Button appearance="primary" color="green" onClick={Save}>
                        ذخیره
                    </rsuite.Button>
                    <rsuite.Button appearance="subtle" onClick={() => setShowModal(false)}>
                        بستن
                    </rsuite.Button>

                </Modal.Footer>
            </Modal>


            <Modal show={ShowPOSModal} onHide={() => setShowPOSModal(false)} size="xl" backdrop="static" keyboard={false}>
                <Modal.Header >
                    <Modal.Title className='fs-5'><b>تعریف POS برای بانک {ShowTitle}</b> </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <rsuite.Grid fluid>

                        <rsuite.Row className="p-1">
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <BiIcon.BiSolidStar className={POSTitle == "" ? 'text-danger' : 'hide'} />  <label>عنوان   </label>
                                <rsuite.Input value={POSTitle} onChange={(e) => (setPOSTitle(e))} />
                            </rsuite.Col>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <rsuite.Checkbox onChange={(e, checked) => setPOSIsActive(checked)} checked={POSIsActive} value={POSIsActive} /> &nbsp;   فعال می باشد
                            </rsuite.Col>

                        </rsuite.Row>
                        <rsuite.Row className="p-1">
                            <rsuite.Col xxl={24} xl={24} lg={24} mdHidden xsHidden smHidden>
                                <rsuite.Panel className="bg-white mt-2 p-0">

                                    <rsuite.Table
                                        height={550}
                                        data={POSList}
                                        wordWrap="break-word"
                                        loading={loading}
                                    // headerHeight={70}
                                    >
                                        <rsuite.Table.Column width={50} align="center" >
                                            <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell dataKey="row" />
                                        </rsuite.Table.Column>

                                        <rsuite.Table.Column width={100} resizable>
                                            <rsuite.Table.HeaderCell>کد</rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell dataKey="Code" />
                                        </rsuite.Table.Column>
                                        <rsuite.Table.Column flexGrow={1} fixed resizable>
                                            <rsuite.Table.HeaderCell>عنوان POS</rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell dataKey="Title" />
                                        </rsuite.Table.Column>




                                        <rsuite.Table.Column flexGrow={1} >
                                            <rsuite.Table.HeaderCell>فعال   </rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell>
                                                {(rowData) => {
                                                    return <>

                                                        {rowData.IsActive == 1 ?

                                                            <BiIcon.BiCheckCircle className="text-success fs-6" />
                                                            :
                                                            <BiIcon.BiXCircle className="text-danger fs-6" />
                                                        }
                                                    </>


                                                }}

                                            </rsuite.Table.Cell>
                                        </rsuite.Table.Column>


                                        <rsuite.Table.Column width={100} fixed='right'>
                                            <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>

                                            <rsuite.Table.Cell>
                                                {(rowData) => {
                                                    return <>
                                                        <rsuite.Whisper placement="autoVerticalStart" trigger="click" speaker={
                                                            <rsuite.Popover full className='PopoverMenu'>
                                                                <rsuite.Dropdown.Menu  >
                                                                    <rsuite.Dropdown.Item onClick={() => ShowPOSEdit(rowData.Id, rowData.Title, rowData.IsActive)}>ویرایش</rsuite.Dropdown.Item>
                                                                    <rsuite.Dropdown.Item className={rowData.FinancialBalance == 0 ? '' : "hide"} onClick={() => ShowPOSDelete(rowData.Id, rowData.Title)}>حذف</rsuite.Dropdown.Item>
                                                                </rsuite.Dropdown.Menu>
                                                            </rsuite.Popover>
                                                        }>
                                                            <rsuite.IconButton appearance="subtle" icon={<BiIcon.BiDotsHorizontalRounded />} />
                                                        </rsuite.Whisper>
                                                    </>
                                                }}
                                            </rsuite.Table.Cell>

                                        </rsuite.Table.Column>
                                    </rsuite.Table>

                                </rsuite.Panel>
                            </rsuite.Col>
                        </rsuite.Row>

                    </rsuite.Grid>
                </Modal.Body>
                <Modal.Footer>
                    <rsuite.Button appearance="primary" color="green" onClick={SavePOS}>
                        ذخیره
                    </rsuite.Button>
                    <rsuite.Button appearance="subtle" onClick={() => setShowPOSModal(false)}>
                        بستن
                    </rsuite.Button>

                </Modal.Footer>
            </Modal>

            <Modal show={ShowCheckBookModal} onHide={() => setShowCheckBookModal(false)} size="xl" backdrop="static" keyboard={false}>
                <Modal.Header >
                    <Modal.Title className='fs-5'><b>تعریف دسته چک برای بانک {ShowTitle}</b> </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <rsuite.Grid fluid>

                        <rsuite.Row className="p-1">
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <rsuite.Checkbox onChange={(e, checked) => setCheckBookIsActive(checked)} checked={CheckBookIsActive} value={CheckBookIsActive} /> &nbsp;   فعال می باشد
                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <BiIcon.BiSolidStar className={CheckBookTitle == "" ? 'text-danger' : 'hide'} />  <label>عنوان </label>
                                <rsuite.Input value={CheckBookTitle} onChange={(e) => (setCheckBookTitle(e))} />
                            </rsuite.Col>
                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                <BiIcon.BiSolidStar className={CheckBookSerialNo == "" ? 'text-danger' : 'hide'} />  <label>سریال  </label>
                                <rsuite.Input value={CheckBookSerialNo} onChange={(e) => (setCheckBookSerialNo(e))} />
                            </rsuite.Col>
                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                <BiIcon.BiSolidStar className={CheckBookPageCount == 0 ? 'text-danger' : 'hide'} />  <label>تعداد برگ  </label>
                                <rsuite.Input value={CheckBookPageCount} onChange={(e) => (setCheckBookPageCount(e))} />
                            </rsuite.Col>
                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                <BiIcon.BiSolidStar className={CheckBookStartNo == 0 ? 'text-danger' : 'hide'} />  <label>شماره اولین برگ </label>
                                <rsuite.Input value={CheckBookStartNo} onChange={(e) => (setCheckBookStartNo(e))} />
                            </rsuite.Col>
                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                <BiIcon.BiSolidStar className={CheckBookStartSayadiNo == 0 ? 'text-danger' : 'hide'} />  <label>شماره صیادی اولین برگ  </label>
                                <rsuite.Input value={CheckBookStartSayadiNo} onChange={(e) => (setCheckBookStartSayadiNo(e))} />
                            </rsuite.Col>


                        </rsuite.Row>
                        <rsuite.Row className="p-1">
                            <rsuite.Col xxl={24} xl={24} lg={24} mdHidden xsHidden smHidden>
                                <rsuite.Panel className="bg-white mt-2 p-0">

                                    <rsuite.Table
                                        height={400}
                                        data={CheckBookList}
                                        wordWrap="break-word"
                                        loading={loading}>
                                        <rsuite.Table.Column width={50} align="center" >
                                            <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell dataKey="row" />
                                        </rsuite.Table.Column>
                                        <rsuite.Table.Column flexGrow={1} resizable>
                                            <rsuite.Table.HeaderCell>عنوان</rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell dataKey="Title" />
                                        </rsuite.Table.Column>
                                        <rsuite.Table.Column flexGrow={1} resizable>
                                            <rsuite.Table.HeaderCell>سریال</rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell dataKey="SerialNo" />
                                        </rsuite.Table.Column>
                                        <rsuite.Table.Column flexGrow={1} resizable>
                                            <rsuite.Table.HeaderCell>تعداد برگ</rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell dataKey="PageCount" />
                                        </rsuite.Table.Column>
                                        <rsuite.Table.Column flexGrow={1} fixed resizable>
                                            <rsuite.Table.HeaderCell> شماره اولین برگ</rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell dataKey="StartNo" />
                                        </rsuite.Table.Column>
                                        <rsuite.Table.Column flexGrow={1} fixed resizable>
                                            <rsuite.Table.HeaderCell> شماره صیادی اولین برگ</rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell dataKey="StartSayadiNo" />
                                        </rsuite.Table.Column>

                                        <rsuite.Table.Column flexGrow={1} >
                                            <rsuite.Table.HeaderCell>فعال   </rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell>
                                                {(rowData) => {
                                                    return <>

                                                        {rowData.IsActive == 1 ?

                                                            <BiIcon.BiCheckCircle className="text-success fs-6" />
                                                            :
                                                            <BiIcon.BiXCircle className="text-danger fs-6" />
                                                        }
                                                    </>


                                                }}

                                            </rsuite.Table.Cell>
                                        </rsuite.Table.Column>

                                        <rsuite.Table.Column width={100} fixed='right'>
                                            <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell>
                                                {(rowData) => {
                                                    return <>
                                                        <rsuite.Whisper placement="autoVerticalStart" trigger="click" speaker={
                                                            <rsuite.Popover full className='PopoverMenu'>
                                                                <rsuite.Dropdown.Menu  >
                                                                    <rsuite.Dropdown.Item onClick={() => ShowCheckBookEdit(rowData.Id)}>ویرایش</rsuite.Dropdown.Item>
                                                                    <rsuite.Dropdown.Item className={rowData.PageUsedCount == 0 ? '' : "hide"} onClick={() => ShowCheckDelete(rowData.Id, rowData.Title)}>حذف</rsuite.Dropdown.Item>
                                                                </rsuite.Dropdown.Menu>
                                                            </rsuite.Popover>
                                                        }>
                                                            <rsuite.IconButton appearance="subtle" icon={<BiIcon.BiDotsHorizontalRounded />} />
                                                        </rsuite.Whisper>
                                                    </>
                                                }}
                                            </rsuite.Table.Cell>
                                        </rsuite.Table.Column>
                                    </rsuite.Table>
                                </rsuite.Panel>
                            </rsuite.Col>
                        </rsuite.Row>

                    </rsuite.Grid>

                </Modal.Body>
                <Modal.Footer>
                    <rsuite.Button appearance="primary" color="green" onClick={SaveCheckBook}>
                        ذخیره
                    </rsuite.Button>
                    <rsuite.Button appearance="subtle" onClick={() => setShowCheckBookModal(false)}>
                        بستن
                    </rsuite.Button>

                </Modal.Footer>
            </Modal>


            <Delete ref={DeleteRef} onSubmit={Search} />
            <Delete ref={DeletePOSRef} onSubmit={() => SearchPOS(Id)} />
            <Delete ref={DeletCheckBookRef} onSubmit={() => SearchCheckBook(Id)} />

        </Layout >


    )
}

export default BankIndex;